import { useMediaQuery } from '~/ui/utils/use-media-query';

export function useHasCursor(initialValue = false): boolean {
  return useMediaQuery('(pointer:fine)', initialValue);
}
